import { Link } from "react-router-dom";
import PublicLayout from "../layouts/PublicLayout";

export default function NotFound() {
  return (
    <PublicLayout>
      <div className="px-4 py-24 text-center">
        <p className="text-xs uppercase tracking-[0.22em] text-rose">404</p>
        <h1 className="mt-3 font-serif text-5xl">This celebration wandered off.</h1>
        <Link to="/" className="btn-gold mt-8">
          Back to Aurelia
        </Link>
      </div>
    </PublicLayout>
  );
}
